/**
 * WHERE A COMPLETED SIGN-IN OR HAND-OFF LANDS - register R-034 (lens finding C2-10).
 *
 * The phone app's hand-off can now carry a destination: `/enter?code=…&next=/articles/<id>/edit`
 * lands the author on that article's editor instead of the cabinet home. `/enter` removes only the
 * `code` from the address (it is a credential), so the `next` is still there when the door hands
 * over, and the router's `AuthDoor` reads it through this function - the same one `/sign-in` uses
 * for the `next` the session gate carries.
 *
 * ★ NO OPEN REDIRECT, TWICE OVER. `returnPathFrom` already refuses anything that is not a
 * same-origin path (`features/auth/navigation.ts`, `safeReturnPath`: no scheme, no `//host`, no
 * `/\host`, no control characters, never back to a door). On top of that a `next` is followed only
 * when its path is one THIS APP ANSWERS - one of the router's own paths, a `$parameter` segment
 * matching exactly one segment - so a crafted link cannot even send an author to a same-origin
 * address the cabinet does not serve. Anything else lands on the cabinet home, as before.
 *
 * `/` is not a landing: it is the bare-address page, a step before the cabinet, not a destination
 * in it. The query and the hash of an accepted `next` ride along unchanged.
 */
import { CABINET_HOME_PATH, returnPathFrom } from '../../features/auth/navigation';

function segmentsOf(path: string): readonly string[] {
  return path.split('/').filter((segment) => segment !== '');
}

/** True when the path part of `pathAndQuery` is one of `paths`, `$param` segments matching any one. */
export function isKnownPath(pathAndQuery: string, paths: readonly string[]): boolean {
  const here = segmentsOf(pathAndQuery.split(/[?#]/, 1)[0] ?? '');
  if (here.length === 0) {
    return false;
  }
  return paths.some((path) => {
    const own = segmentsOf(path);
    return (
      own.length === here.length &&
      own.every((segment, index) => segment.startsWith('$') || segment === here[index])
    );
  });
}

/** The carried `next` when it names a screen among `paths`, else the cabinet's home. */
export function landingPathAmong(search: string, paths: readonly string[]): string {
  const carried = returnPathFrom(search);
  return carried !== null && isKnownPath(carried, paths) ? carried : CABINET_HOME_PATH;
}
